<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜尋 用戶名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用戶名稱" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="用戶名稱"></el-input>
						</el-form-item>

						<el-form-item label="用戶編號" class="mb-0">
							<el-input size="small" v-model="from.user_no" placeholder="用戶編號"></el-input>
						</el-form-item>
						
						<el-form-item label="學校名稱" class="mb-0">
							<el-input size="small" v-model="from.school_name" placeholder="學校名稱"></el-input>
						</el-form-item>
						
						<el-form-item label="IP地址" class="mb-0">
							<el-input size="small" v-model="from.ip" placeholder="IP地址"></el-input>
						</el-form-item>
						
						<el-form-item label="登錄時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center" prop="user_no" label="用戶編號" >
				</el-table-column>

				<el-table-column align="center" prop="username" label="用戶名稱" >
				</el-table-column>
				
				<el-table-column align="center" prop="school_name" label="學校名稱" >
				</el-table-column>
					
				<el-table-column align="center" prop="create_time" label="登錄時間" sortable="custom">
				</el-table-column>
				
				<el-table-column align="center" prop="version" label="登錄版本" width="140">
				</el-table-column>
					
				<el-table-column align="center" prop="ip" label="IP地址" >
				</el-table-column>
					
				<el-table-column align="center" prop="phone_type" label="設備信息">
				</el-table-column>
					
				<el-table-column align="center" prop="phone_info" label="設備型號" >
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

	
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				createModelInfo: false,
				editIndex: -1,
				//搜索數据
				from: {
					username: '',
					user_no: '',
					school_name: '',
					ip: '',
					time: [],
				},
				model_title: 'LoginLog',
				auth_val: 'LoginLog',
				preUrl: "user/loginLogList", //列表地址
				delAllUrl: "", //批量删除地址
				delUrl: "", //删除單条地址
				editStatusUrl: "", //修改狀態地址

				tableData: [],
				
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			// this.commonList(['subject_list','grade_list']);
		},
		methods: {
			tableRowClassName({row, rowIndex}) {
				return '';
			},
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					username: '',
					user_no: '',
					school_name: '',
					ip: '',
					time: [],
				}
				this.search = ''
				this.getList()
			},
		}
	}
</script>


<style>
 .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .el-table .danger-row {
    background: rgb(253, 226, 226)
  }

  .is-disabled {
	cursor: not-allowed;  /* 禁止光標样式 */
	color: #c0c4cc;       /* 灰色文字 */
	background-color: #f5f7fa; /* 灰色背景 */
  }
</style>

